module.exports = __webpack_public_path__ + "img/aws.99fd7e77.svg";